import styled from 'styled-components';

import TextTooltip from '../TextTooltip';

export const StyledTextTooltip = styled(TextTooltip)`
  display: inline-flex;
`;
